export default {
  title: {
    id: 'merchant_options_shipping_method_delete_modal_title',
    defaultMessage: 'Delete this shipping method',
  },
  body: {
    id: 'merchant_options_shipping_method_delete_modal_body',
    defaultMessage: 'Are you sure you want to delete this shipping method?',
  },
  confirm: {
    id: 'merchant_options_shipping_method_delete_modal_confirmation',
    defaultMessage: 'Yes, delete this shipping method',
  },
  cancel: {
    id: 'merchant_options_shipping_method_delete_modal_cancel',
    defaultMessage: 'Cancel',
  },
  errorTitle: {
    id: 'merchant_options_shipping_method_delete_modal_error_title',
    defaultMessage: 'Oops, something went wrong.',
  },
} as const
